import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";

var _dec, _dec2, _dec3, _dec4, _class, _class2;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Flow } from '../libs';
import { Initialize, GetReady, Required } from '../decorators';
import { LOGIN_INIT, LOGIN_VERIFY, LOGIN_SEND_SMS, LOGIN_VERIFY_SMS } from '../constants';

/**
 * 登陆模块
 * @link https://shopline.yuque.com/sczv0i/zbwfmf/ewlur8
 */
export var LoginFlow = (_dec = Required(['_stoken']), _dec2 = Required(['_stoken']), _dec3 = Required(['_stoken']), _dec4 = Required(['_stoken']), (_class = (_class2 = /*#__PURE__*/function (_Flow) {
  _inherits(LoginFlow, _Flow);

  var _super = _createSuper(LoginFlow);

  function LoginFlow() {
    _classCallCheck(this, LoginFlow);

    return _super.apply(this, arguments);
  }

  _createClass(LoginFlow, [{
    key: "init",
    value:
    /** 初始化 */
    function init(params) {
      return this.request(LOGIN_INIT, params);
    }
    /** 账号密码登陆 */

  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var pwd, finalParams, rst, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pwd = params.pwd;
                finalParams = Object.assign({}, params, {
                  pwd: this.encrypt(pwd)
                });
                _context.next = 4;
                return this.request(LOGIN_VERIFY, finalParams);

              case 4:
                rst = _context.sent;
                data = rst.data;
                _context.next = 8;
                return this.setCookies(data === null || data === void 0 ? void 0 : data.ck);

              case 8:
                return _context.abrupt("return", rst);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function verify(_x) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
    /** 账号密码登陆 不自动调用init接口获取stoken，需要传入stoken */

  }, {
    key: "verifyWithNoInit",
    value: function () {
      var _verifyWithNoInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var pwd, finalParams;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                pwd = params.pwd;
                finalParams = Object.assign({}, params, {
                  pwd: this.encrypt(pwd)
                });
                _context2.next = 4;
                return this.request(LOGIN_VERIFY, finalParams);

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function verifyWithNoInit(_x2) {
        return _verifyWithNoInit.apply(this, arguments);
      }

      return verifyWithNoInit;
    }()
    /** 获取短信验证码 */

  }, {
    key: "sendSms",
    value: function () {
      var _sendSms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.request(LOGIN_SEND_SMS, params));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function sendSms(_x3) {
        return _sendSms.apply(this, arguments);
      }

      return sendSms;
    }()
    /** 验证登录 */

  }, {
    key: "verifySMS",
    value: function () {
      var _verifySMS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        var _yield$this$request, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.request(LOGIN_VERIFY_SMS, params);

              case 2:
                _yield$this$request = _context4.sent;
                data = _yield$this$request.data;
                _context4.next = 6;
                return this.setCookies(data === null || data === void 0 ? void 0 : data.ck);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function verifySMS(_x4) {
        return _verifySMS.apply(this, arguments);
      }

      return verifySMS;
    }()
  }]);

  return LoginFlow;
}(Flow), _defineProperty(_class2, "flowName", 'LoginFlow'), _class2), (_applyDecoratedDescriptor(_class.prototype, "init", [Initialize], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "verify", [GetReady, _dec], Object.getOwnPropertyDescriptor(_class.prototype, "verify"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "verifyWithNoInit", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "verifyWithNoInit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendSms", [GetReady, _dec3], Object.getOwnPropertyDescriptor(_class.prototype, "sendSms"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "verifySMS", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "verifySMS"), _class.prototype)), _class));